<template>
  <div>
    <b-modal
      id="update-version-modal"
      ref="update-version-modal"
      :title="$t('message.versionupdate')"
      hideHeaderClose
      hideFooter
      noCloseOnBackdrop
    >
      <div>
        <span>{{ $t('message.waitforamomentforupdate') }}</span>
        <a
          :href="`https://www.treesoft.io/th/version?v=${$store.getters['getAppLatestVersion']}`"
          target="_blank">
          {{ $t('message.version', {'string': $store.getters['getAppLatestVersion']}) }}
          <i class="fas fa-external-link-alt"/>
        </a>
      </div>
      <div
        class="progress mt-3"
        style="height: 3px;">
        <div
          :style="`width: ${progress}%;`"
          :aria-valuenow="progress"
          class="progress-bar"
          role="progressbar"
          aria-valuemin="0"
          aria-valuemax="100"/>
      </div>
    </b-modal>
  </div>
</template>

<script>
import { compare } from 'compare-versions'

export default {
  data () {
    return {
      progress: 0,
      loadingTime: 1000 * 3, // loading time to update (1000 = 1 sec)
      delayTime: 500, // delay time (1000 = 1 sec)
    }
  },
  mounted: function () {
    this.detectAppVersion()
  },
  methods: {
    progressStart (callback) {
      var i = 0
      var timer = setInterval(() => {
        if (i < (this.loadingTime / this.delayTime)) {
          this.progress += 100 / (this.loadingTime / this.delayTime)
          i++
        } else {
          clearInterval(timer)
          callback()
        }
      }, this.delayTime)
    },
    async detectAppVersion () {
      // call api to get latest version
      await this.$store.dispatch('getAppLatestVersion')
      // get latest version in state
      const latestVersion = this.$store.getters['getAppLatestVersion']
      // get current version in state
      const currentVersion = this.$store.getters['getAppCurrentVersion']
      const isMajor = (() => {
        const arr = `${latestVersion}`.split('.')
        if (arr[2] == '0') {
          return true
        }
        return false
      })()
      // check out of date
      const isOldVersion = compare(currentVersion, latestVersion, '<')
      if (isOldVersion) {
        if (isMajor) {
          // this.$refs['update-version-modal'].show()
          // this.progressStart(() => { // loading done
          //   location.reload()
          // })
          location.reload()
        } else {
          location.reload()
        }
      }
    },
  },
}
</script>



// WEBPACK FOOTER //
// src/components/version/DetectVersion.vue